<template>
  <v-toolbar app>
    <v-toolbar-side-icon @click.stop="handleDrawer"></v-toolbar-side-icon>
  </v-toolbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      drawer: "getDrawer"
    })
  },
  methods: {
    ...mapActions(["setDrawerData"]),
    handleDrawer() {
      this.setDrawerData(!this.drawer);
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.v-toolbar {
  height: 25px;
  background-color: none !important;
  box-shadow: none;
  position: relative !important;
}
</style>